import request from "@/utils/request.js";
// import qs from "qs";

// 查询启用的数据
export function listEnableHxFooter() {
    return request({
        url: "/website/footer/listEnableHxFooter",
        method: "get",
    });
}

// //获取用户数据
// export function getUserInfo(params) {
//     return request({
//         url: baseUrl + "/getUserInfo",
//         method: "get",
//         params:qs.stringfy(params)
//     });
// }
